<template>
  <div class="contianer">
    <page-header from="index"></page-header>
    <div class="main">
      <search
        :cur-type="params.type"
        :cur-key="params.key"
        @searchKey="doSearch"
      ></search>
      <div class="result-box">
        <!-- 错误信息 -->
        <el-empty
          class="empty-box"
          v-if="errTips"
          :description="errTips"
        ></el-empty>
        <div v-else-if="!loading">
          <!-- 商品信息查询 -->
          <div v-if="params.type == 'goods_id'">
            <div class="func-section-title">
              <p class="title">商品信息</p>
              <p class="desc">COMMODITY INFORMATION</p>
            </div>
            <div class="section base-info-section">
              <div class="section-title">基本信息</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">商品ID：</p>
                  <p class="con" :title="assetInfo.assetId">
                    {{ assetInfo.assetId }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">发行时间：</p>
                  <p class="con">{{ assetInfo.publishTime }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">创作者：</p>
                  <p class="con">{{ assetInfo.merchantName }}</p>
                </div>
                <div class="info-item divider">
                  <p class="item-label">流通量：</p>
                  <p class="con">{{ assetInfo.flow }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">商品名称：</p>
                  <p class="con" :title="assetInfo.goods_name">
                    {{ assetInfo.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="section trade-info-section">
              <div class="section-title">交易信息</div>
              <div class="section-container" v-if="list.records.length">
                <div
                  class="trade-item"
                  v-for="item in list.records"
                  :key="item.hash"
                >
                  <div class="info-item">
                    <p class="item-label">交易哈希：</p>
                    <p class="con">
                      <a
                        class="link-con"
                        href="javascript:void(0)"
                        @click="reloadPage('trade_hash', item.hash)"
                        >{{ item.hash }}
                      </a>
                      <i
                        title="点击复制"
                        class="el-icon-copy-document"
                        @click="copyText(item.hash)"
                      ></i>
                    </p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">商品ID：</p>
                    <p class="con" :title="assetInfo.assetId">
                      {{ assetInfo.assetId }}
                    </p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">子ID：</p>
                    <p class="con" :title="item.shardId">{{ item.shardId }}</p>
                  </div>
                  <div class="info-item">
                    <p class="item-label">发送方：</p>
                    <a
                      class="link-con"
                      href="javascript:void(0)"
                      :title="item.address"
                      @click="reloadPage('addr', item.address)"
                    >
                      {{ item.address }}
                    </a>
                  </div>
                  <div class="info-item">
                    <p class="item-label">接收方：</p>
                    <a
                      class="link-con"
                      href="javascript:void(0)"
                      :title="item.toAddress"
                      @click="reloadPage('addr', item.toAddress)"
                    >
                      {{ item.toAddress }}
                    </a>
                  </div>
                  <div class="info-item">
                    <p class="item-label">交易时间：</p>
                    <p class="con" :title="item.txnTime">{{ item.txnTime }}</p>
                  </div>
                </div>
                <div class="pagination-container">
                  <el-pagination
                    :hide-on-single-page="true"
                    layout="prev, pager, next"
                    :page-size="params.page_size"
                    :total="list.total"
                    :current-page="params.page"
                    @current-change="getReuslt"
                  >
                  </el-pagination>
                </div>
              </div>
              <el-empty v-else description="暂无交易信息"></el-empty>
            </div>
          </div>

          <!-- 存证信息查询 -->
          <div v-if="params.type == 'evidence'">
            <div class="func-section-title">
              <p class="title">存证信息</p>
              <p class="desc">EVIDENCE INFORMATION</p>
            </div>
            <div class="section base-info-section">
              <div class="section-title">基本信息</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">存证ID：</p>
                  <p class="con" :title="assetInfo.id">
                    {{ assetInfo.id }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证主体：</p>
                  <p class="con">
                    {{ assetInfo.identityType }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证主体名称：</p>
                  <p class="con">{{ assetInfo.identityName }}</p>
                </div>

                <div class="info-item">
                  <p class="item-label">存证主体号码：</p>
                  <p class="con">{{ assetInfo.identityNum }}</p>
                </div>

                <div class="info-item">
                  <p class="item-label">存证类别：</p>
                  <p class="con">
                    {{
                      assetInfo.evidenceCate == 1
                        ? "版权存证"
                        : assetInfo.evidenceCate == 2
                        ? "数据存证"
                        : "交易存证"
                    }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">数据名称：</p>
                  <p class="con">{{ assetInfo.name }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">数据类别：</p>
                  <p class="con">{{ assetInfo.cate | cateName }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证数据类型：</p>
                  <p class="con">{{ assetInfo.type | typeName }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">文件名称：</p>
                  <p class="con">{{ assetInfo.fileName }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">文件字节：</p>
                  <p class="con">{{ assetInfo.fileBytes + "字节" }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">数据哈希类型：</p>
                  <p class="con">{{ assetInfo.hashType | hashTypeName }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label" :title="assetInfo.hash">数据哈希：</p>
                  <p class="con">{{ assetInfo.hash }}</p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证哈希：</p>
                  <p class="con" :title="assetInfo.txId">
                    {{ assetInfo.txId || "--" }}
                  </p>
                </div>
                <div class="info-item auto-height">
                  <p class="item-label">交易消息数据：</p>
                  <p class="con">
                    <json-viewer
                      :value="JSON.parse(assetInfo.dataJson)"
                      :expand-depth="5"
                      boxed
                      sort
                      :show-array-index="false"
                      :copyable="{ copyText: '复制', copiedText: '复制成功' }"
                      @copied="copied"
                      class="jv-light"
                    >
                      <template slot="copy">
                        <i class="el-icon-document-copy" title="复制"></i>
                      </template>
                    </json-viewer>
                  </p>
                </div>

                <div class="info-item auto-height">
                  <p class="item-label">存证链接：</p>
                  <el-image
                    v-if="assetInfo.evidenceUrl"
                    style="width:300px;"
                    :src="assetInfo.evidenceUrl"
                    :preview-src-list="[assetInfo.evidenceUrl]"
                    title="点击预览大图"
                    lazy
                  ></el-image>
                  <p class="con" v-else>--</p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证状态：</p>
                  <p class="con">
                    <el-tag v-if="assetInfo.status == 1" type="success">
                      已存证
                    </el-tag>
                    <el-tag v-else-if="assetInfo.status == 2" type="danger">
                      已销毁
                    </el-tag>
                    <el-tag v-else>存证中</el-tag>
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">存证时间：</p>
                  <p class="con">
                    {{ assetInfo.evidenceTime || "--" }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- 交易哈希查询结果 -->
          <div v-if="params.type == 'trade_hash'">
            <div class="func-section-title">
              <p class="title">交易详情</p>
              <p class="desc">TRANSACTION DVETAILS</p>
            </div>
            <div class="section base-info-section">
              <div class="section-title">基本信息</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">交易哈希：</p>
                  <p
                    class="con"
                    :title="assetInfo.hash"
                    @click="copyText(assetInfo.hash)"
                  >
                    {{ assetInfo.hash
                    }}<i title="点击复制" class="el-icon-copy-document"></i>
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">原始哈希：</p>
                  <p class="con" v-if="assetInfo.originalTxId">
                    <a
                      class="link-con"
                      href="javascript:void(0)"
                      @click="
                        reloadPage('origin_trade_hash', assetInfo.originalTxId)
                      "
                      >{{ assetInfo.originalTxId }}
                    </a>
                    <i
                      title="点击复制"
                      class="el-icon-copy-document"
                      @click="copyText(assetInfo.originalTxId)"
                    ></i>
                  </p>
                  <p v-else class="con">
                    {{ assetInfo.originalTxId || "--" }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">交易状态：</p>
                  <p class="con">
                    <el-tag
                      v-if="assetInfo.txnStatus == 0"
                      type="danger"
                      size="small"
                      >失败</el-tag
                    >
                    <el-tag v-else type="success" size="small">成功</el-tag>
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">商品ID：</p>
                  <a
                    class="link-con"
                    href="javascript:void(0)"
                    @click="reloadPage('goods_id', assetInfo.assetId)"
                    >{{ assetInfo.assetId }}</a
                  >
                </div>
                <div class="info-item">
                  <p class="item-label">子ID：</p>
                  <p class="con" :title="assetInfo.shard_id">
                    {{ assetInfo.shardId }}
                  </p>
                </div>
                <div class="info-item divider">
                  <p class="item-label">发起时间：</p>
                  <p class="con">{{ assetInfo.createTime }}</p>
                </div>
                <div class="info-item" v-if="assetInfo.blockTime">
                  <p class="item-label">出块时间：</p>
                  <p class="con">{{ assetInfo.blockTime }}</p>
                </div>
                <div class="info-item divider" v-if="assetInfo.blockHeight">
                  <p class="item-label">区块高度：</p>
                  <p class="con">{{ assetInfo.blockHeight }}</p>
                </div>
              </div>
            </div>
            <div class="section base-info-section">
              <div class="section-title">概述</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">交易类型：</p>
                  <p class="con">
                    {{ assetInfo.txnType == 1 ? "发行NFT" : "转让NFT" }}
                  </p>
                </div>
                <div class="info-item">
                  <p class="item-label">发起方：</p>
                  <div class="con-box" v-if="assetInfo.address">
                    <a
                      class="con"
                      href="javascript:void(0)"
                      :title="assetInfo.address"
                      @click="reloadPage('addr', assetInfo.address)"
                      >{{ assetInfo.address }}
                    </a>
                    <i
                      title="点击复制"
                      @click="copyText(assetInfo.address)"
                      class="el-icon-copy-document"
                    ></i>
                  </div>
                  <p v-else class="con">--</p>
                </div>
                <div class="info-item">
                  <p class="item-label">接收方：</p>
                  <div class="con-box">
                    <a
                      class="con"
                      href="javascript:void(0)"
                      :title="assetInfo.toAddress"
                      @click="reloadPage('addr', assetInfo.toAddress)"
                      >{{ assetInfo.toAddress }}
                    </a>
                    <i
                      title="点击复制"
                      @click="copyText(assetInfo.toAddress)"
                      class="el-icon-copy-document"
                    ></i>
                  </div>
                </div>
                <div
                  class="info-item"
                  :class="{
                    'auto-height':
                      assetInfo.dataJson &&
                      assetInfo.dataJson.indexOf('.json') == -1
                  }"
                >
                  <p class="item-label">交易消息数据：</p>
                  <p class="con">
                    <span v-if="!assetInfo.dataJson">--</span>
                    <a
                      v-else-if="assetInfo.dataJson.indexOf('.json') > -1"
                      :href="assetInfo.dataJson"
                      target="_blank"
                      >{{ assetInfo.dataJson }}</a
                    >
                    <json-viewer
                      v-else
                      :value="JSON.parse(assetInfo.dataJson)"
                      :expand-depth="5"
                      boxed
                      sort
                      :show-array-index="false"
                      :copyable="{ copyText: '复制', copiedText: '复制成功' }"
                      @copied="copied"
                      class="jv-light"
                    >
                      <template slot="copy">
                        <i class="el-icon-document-copy" title="复制"></i>
                      </template>
                    </json-viewer>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- 原始交易哈希查询结果 -->
          <div v-if="params.type == 'origin_trade_hash'">
            <div class="func-section-title">
              <p class="title">交易详情</p>
              <p class="desc">TRANSACTION DVETAILS</p>
            </div>
            <div class="section base-info-section">
              <div class="section-title">交易详情</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">交易类型：</p>
                  <p class="con">
                    {{ assetInfo.txType }}
                  </p>
                </div>

                <div class="info-item">
                  <p class="item-label">发起方：</p>
                  <div class="con-box" v-if="assetInfo.from">
                    <a
                      class="con"
                      href="javascript:void(0)"
                      :title="assetInfo.from"
                      @click="reloadPage('addr', assetInfo.from)"
                      >{{ assetInfo.from }}
                    </a>
                    <i
                      title="点击复制"
                      @click="copyText(assetInfo.from)"
                      class="el-icon-copy-document"
                    ></i>
                  </div>
                  <p v-else class="con">--</p>
                </div>
                <div class="info-item">
                  <p class="item-label">接收方：</p>
                  <div class="con-box">
                    <a
                      class="con"
                      href="javascript:void(0)"
                      :title="assetInfo.to"
                      @click="reloadPage('addr', assetInfo.to)"
                      >{{ assetInfo.to }}
                    </a>
                    <i
                      title="点击复制"
                      @click="copyText(assetInfo.to)"
                      class="el-icon-copy-document"
                    ></i>
                  </div>
                </div>
                <div class="info-item divider">
                  <p class="item-label">交易时间：</p>
                  <p class="con">{{ assetInfo.timestamp }}</p>
                </div>
              </div>
            </div>
            <div class="section base-info-section">
              <div class="section-title">交易数据</div>
              <div class="section-container">
                <div class="info-item">
                  <p class="item-label">原始哈希：</p>
                  <p
                    v-if="assetInfo.hash"
                    class="con"
                    :title="assetInfo.hash"
                    @click="copyText(assetInfo.hash)"
                  >
                    {{ assetInfo.hash
                    }}<i title="点击复制" class="el-icon-copy-document"></i>
                  </p>
                  <p v-else class="con">
                    {{ assetInfo.hash || "--" }}
                  </p>
                </div>
                <div class="info-item divider" v-if="assetInfo.blockHeight">
                  <p class="item-label">区块高度：</p>
                  <p class="con">{{ assetInfo.blockNumber }}</p>
                </div>
                <div class="info-item" v-if="assetInfo.nonce">
                  <p class="item-label">Nonce：</p>
                  <p class="con">{{ assetInfo.nonce }}</p>
                </div>
                <div class="info-item" v-if="assetInfo.gas">
                  <p class="item-label">交易Gas</p>
                  <p class="con">{{ assetInfo.gas }}</p>
                </div>
                <div
                  class="info-item"
                  :class="{
                    'auto-height': assetInfo.signature
                  }"
                >
                  <p class="item-label">签名：</p>
                  <p class="con">
                    <span v-if="!assetInfo.signature">--</span>
                    <json-viewer
                      v-else
                      :value="assetInfo.signature"
                      :expand-depth="5"
                      boxed
                      sort
                      :show-array-index="false"
                      :copyable="{ copyText: '复制', copiedText: '复制成功' }"
                      @copied="copied"
                      class="jv-light"
                    >
                      <template slot="copy">
                        <i class="el-icon-document-copy" title="复制"></i>
                      </template>
                    </json-viewer>
                  </p>
                </div>
                <div
                  class="info-item"
                  :class="{
                    'auto-height': assetInfo.data
                  }"
                >
                  <p class="item-label">交易收据：</p>
                  <p class="con">
                    <span v-if="!assetInfo.data">--</span>
                    <json-viewer
                      v-else
                      :value="assetInfo.data"
                      :expand-depth="5"
                      boxed
                      sort
                      :show-array-index="false"
                      :copyable="{ copyText: '复制', copiedText: '复制成功' }"
                      @copied="copied"
                      class="jv-light"
                    >
                      <template slot="copy">
                        <i class="el-icon-document-copy" title="复制"></i>
                      </template>
                    </json-viewer>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- 地址查询结果 -->
          <div v-if="params.type == 'addr'">
            <div class="func-section-title">
              <p class="title">账户信息</p>
              <p class="desc">ACCOUNT INFORMATION</p>
            </div>
            <div class="addr-info-section">
              <div class="addr-box" @click="copyText(assetInfo.key)">
                <p class="con" :title="assetInfo.key">
                  {{ assetInfo.addr }}
                </p>
                <i title="点击复制" class="el-icon-copy-document"></i>
              </div>
              <div class="time-box">
                <div class="time-info">
                  <p class="label"><i class="icon-question"></i>最近交易</p>
                  <p class="val">{{ assetInfo.transaction_latest_time }}</p>
                </div>
                <div class="time-info">
                  <p class="label"><i class="icon-question"></i>创建于</p>
                  <p class="val">{{ assetInfo.account_create_time }}</p>
                </div>
              </div>
            </div>
            <div class="section trade-info-section">
              <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
                <el-tab-pane label="资产" name="assets">
                  <div class="tab-title">
                    持有商品信息
                  </div>
                  <div class="section-container" v-if="list.records">
                    <div class="record-table-wrapper">
                      <table
                        class="record-table"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tr>
                          <th>商品ID</th>
                          <th>创作者</th>
                          <th>子ID</th>
                          <th class="center">状态</th>
                        </tr>
                        <tr v-for="(item, index) in list.records" :key="index">
                          <td>
                            <a
                              class="link-con"
                              href="javascript:void(0)"
                              @click="reloadPage('goods_id', item.assetId)"
                              >{{ item.assetId }}</a
                            >
                          </td>
                          <td>{{ item.merchantName }}</td>
                          <td>{{ item.shardId }}</td>
                          <td class="center">
                            <el-tag
                              v-if="item.status == 1"
                              type="success"
                              size="small"
                              >正常</el-tag
                            >
                            <el-tag v-else type="danger" size="small"
                              >销毁</el-tag
                            >
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="pagination-container">
                      <el-pagination
                        :hide-on-single-page="true"
                        layout="prev, pager, next"
                        :page-size="params.page_size"
                        :total="list.total"
                        :current-page="params.page"
                        @current-change="getReuslt"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="交易记录" name="trade">
                  <div class="tab-title">
                    <i class="icon-question"></i>共
                    <span class="num">{{ list.total }}笔</span>交易
                  </div>
                  <div class="section-container" v-if="list.records.length">
                    <div class="record-table-wrapper">
                      <el-table :data="list.records" style="width: 100%">
                        <el-table-column prop="hash" label="交易哈希">
                          <template slot-scope="scope">
                            <a
                              class="link-con"
                              href="javascript:void(0)"
                              @click="reloadPage('trade_hash', scope.row.hash)"
                              >{{ scope.row.hash }}
                            </a>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="create_time"
                          label="时间"
                          width="130"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.blockTime | timeAgo }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="from" label="从">
                          <template slot-scope="scope">
                            <div class="dis-flex">
                              <a
                                class="link-con"
                                href="javascript:void(0)"
                                @click="reloadPage('addr', scope.row.address)"
                              >
                                {{ scope.row.address }}
                              </a>
                              <i
                                title="点击复制"
                                class="el-icon-copy-document m-left-5"
                                @click="copyText(scope.row.address)"
                              ></i>
                              <el-tag
                                class="m-left-5"
                                type="success"
                                size="small"
                                >转入</el-tag
                              >
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="to" label="到">
                          <template slot-scope="scope">
                            <div class="dis-flex">
                              <a
                                class="link-con"
                                href="javascript:void(0)"
                                @click="reloadPage('addr', scope.row.toAddress)"
                              >
                                {{ scope.row.toAddress }}
                              </a>
                              <i
                                title="点击复制"
                                class="el-icon-copy-document m-left-5"
                                @click="copyText(scope.row.toAddress)"
                              ></i>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="height"
                          label="区块高度"
                          width="120"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.blockHeight }}
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="type"
                          label="交易消息类型"
                          align="center"
                          width="120"
                        >
                          <template slot-scope="scope">
                            交易NFT
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="pagination-container">
                      <el-pagination
                        :hide-on-single-page="true"
                        layout="prev, pager, next"
                        :page-size="params.page_size"
                        :total="list.total"
                        :current-page="params.page"
                        @current-change="getReuslt"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer";
import pageHeader from "@/components/page-header";
import pageFooter from "@/components/page-footer";
import search from "@/components/search";
import { formatNum } from "@/utils/comm.js";
export default {
  name: "home",
  components: {
    JsonViewer,
    pageHeader,
    pageFooter,
    search
  },
  data() {
    return {
      activeTabName: "assets",
      params: {
        type: "",
        page: 1,
        key: "",
        page_size: 10
      },
      txnParams: {
        type: "",
        page: 1,
        key: "",
        page_size: 10,
        list: []
      },
      assetInfo: {},
      list: {},
      errTips: "",
      loading: false,
      tradeJSON: "" //交易消息数据
    };
  },
  mounted() {
    let { type, key } = this.$route.query;
    this.searchKey(type, key);
  },
  filters: {
    timeAgo(datetime) {
      const seconds = 1000;
      const minutes = seconds * 60;
      const hours = minutes * 60;
      const days = hours * 24;

      const now = new Date().getTime();
      const diffValue = now - datetime;

      if (diffValue < 0) return "Not yet";

      const diffSeconds = Math.floor(diffValue / seconds);
      const diffMinutes = Math.floor(diffValue / minutes);
      const diffHours = Math.floor(diffValue / hours);
      const diffDays = Math.floor(diffValue / days);

      if (diffDays > 7) return new Date(datetime).toLocaleDateString();
      if (diffDays >= 1) return `${diffDays} 天前`;
      if (diffHours >= 1) return `${diffHours} 小时前`;
      if (diffMinutes >= 1) return `${diffMinutes} 分钟前`;
      if (diffSeconds >= 1) return `${diffSeconds} 秒前`;
      return "刚刚";
    },
    cateName(cate) {
      let name = "";
      switch (cate) {
        case 1:
          name = "其它类型";
          break;
        case 2:
          name = "文字作品";
          break;
        case 3:
          name = "口述作品";
          break;
        case 4:
          name = "音乐作品";
          break;
        case 5:
          name = "戏剧作品";
          break;
        case 6:
          name = "曲艺作品";
          break;
        case 7:
          name = "舞蹈作品";
          break;
        case 8:
          name = "美术作品";
          break;
        case 9:
          name = "美术作品";
          break;
        case 10:
          name = "建筑作品";
          break;
        case 11:
          name = "摄影作品";
          break;
        case 12:
          name = "视听作品";
          break;
        case 13:
          name = "图形作品（工程设计图、产品设计图、地图、示意图等）";
          break;
        case 14:
          name = "模型作品";
          break;
      }
      return name;
    },
    typeName(type) {
      let name = "";
      switch (type) {
        case 1:
          name = "文字文件";
          break;
        case 2:
          name = "图片文件";
          break;
        case 3:
          name = "视频文件";
          break;
        case 4:
          name = "多媒体文件";
          break;
        case 5:
          name = "压缩包文件";
          break;
      }
      return name;
    },
    hashTypeName(type) {
      let name = "";
      switch (type) {
        case 1:
          name = "其它";
          break;
        case 2:
          name = "SHA256";
          break;
        case 3:
          name = "MD5";
          break;
        case 4:
          name = "SHA256-PFV";
          break;
      }
      return name;
    }
  },
  methods: {
    copied() {
      this.$message.success("复制成功");
    },
    handleTabClick() {
      this.getReuslt();
    },
    async copyText(text) {
      try {
        const textToCopy = text;
        await navigator.clipboard.writeText(textToCopy);
        this.$message.success("复制成功");
      } catch (error) {
        this.$message.error("复制失败:" + error);
      }
    },
    reloadPage(type, key) {
      if (type == this.params.type && key == this.params.key) {
        this.searchKey(type, key);
        return;
      }

      this.$router.push(`search?type=${type}&key=${key}`);
    },
    doSearch(obj) {
      this.searchKey(obj.type, obj.key);
    },
    searchKey(type, key) {
      if (!key || !type) {
        return;
      }
      this.params.key = key;
      this.params.type = type;
      this.getReuslt();
    },
    getReuslt(page) {
      this.errTips = "";
      this.params.page = page || 1;

      if (!this.params.key) {
        this.assetInfo = {};
        this.list = {};
        return;
      }

      this.loading = true;

      let searchType = this.params.type;

      if (searchType == "goods_id") {
        //  商品查询
        this.queryGoods(page);
      } else if (searchType == "evidence") {
        //  存证查询
        this.queryEvidence(page);
      } else if (searchType == "trade_hash") {
        //  哈希查询
        this.queryTransaction();
      } else if (searchType == "origin_trade_hash") {
        // 原始哈希查询
        this.queryTransactionDetail();
      } else if (searchType == "addr") {
        //  账号地址查询
        if (this.activeTabName === "assets") {
          this.queryAddress(page);
        } else {
          this.queryAddressTxnInfo(page);
        }
      }
    },
    queryAddressTxnInfo() {
      this.$api
        .queryAddressTxnInfo({
          addr: this.params.key,
          page: this.params.page
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            this.list = res.data || {};
          } else {
            this.errTips = res.message;
            this.list = {};
          }
        });
    },
    // 地址查询
    queryAddress() {
      this.$api
        .queryAddress({
          addr: this.params.key,
          page: this.params.page
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            this.list = res.data || {};
            this.assetInfo = {
              addr: this.params.key,
              account_create_time: res.data.account_create_time || "--",
              transaction_latest_time: res.data.transaction_latest_time || "--"
            };
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    queryTransaction() {
      let hash = this.params.key;
      this.$api
        .queryTransaction({
          tx_id: hash
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            let assetInfo = res.data;
            assetInfo.hash = hash;
            assetInfo.blockHeight =
              assetInfo.blockHeight != null
                ? formatNum(assetInfo.blockHeight)
                : "--";
            this.assetInfo = assetInfo;
            this.list = {};
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    // 原始哈希数据
    queryTransactionDetail() {
      let hash = this.params.key;
      this.$api
        .queryTransactionDetail({
          tx_id: hash
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            let assetInfo = res.data;
            assetInfo.hash = hash;
            assetInfo.blockHeight =
              assetInfo.blockHeight != null
                ? formatNum(assetInfo.blockHeight)
                : "--";
            this.assetInfo = assetInfo;
            this.list = {};
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    },
    // 存证查询
    queryEvidence() {
      let data = this.params.key.trim();
      this.$api
        .queryEvidence({
          id: data.length <= 32 ? data : "",
          tx_id: data.length > 32 ? data : "",
          page: this.params.page
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            this.assetInfo = res.data;
          } else {
            this.assetInfo = {};
            this.errTips = res.message;
          }
        });
    },
    // 商品ID查询
    queryGoods() {
      this.$api
        .queryGoods({
          asset_id: this.params.key,
          page: this.params.page
        })
        .then(res => {
          res = res.data;
          this.loading = false;
          if (res.code == 1) {
            let data = res.data;
            let assetInfo = data.asset_info;
            assetInfo.assetId = this.params.key;
            assetInfo.total_num = formatNum(assetInfo.total_num);
            this.assetInfo = assetInfo;
            this.list = data.tx_info;
          } else {
            this.assetInfo = {};
            this.list = {};
            this.errTips = res.message;
          }
        });
    }
  }
};
</script>
<style></style>
<style scoped>
.jv-container.jv-light {
  background-color: #f7f8fa;
  border-color: #e8eaf3;
}
.result-box {
  min-height: 400px;
  max-width: 1200px;
  margin: 40px auto;
}
.addr-info-section {
  margin-bottom: 24px;
  margin-left: 24px;
  height: 57px;
  border-bottom: 1px solid #e8eaf3;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 15px;
}
.addr-info-section .addr-box {
  flex-shrink: 1;
  flex-grow: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 50%;
}
.addr-info-section .addr-box .con {
  font-weight: 600;
  font-size: 24px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}
.addr-info-section .addr-box i {
  margin-left: 10px;
  font-size: 16px;
  color: #91979d;
  flex-shrink: 0;
  background-color: #dadfe3;
  height: 28px;
  width: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 50%;
  font-weight: bold;
}
.addr-info-section .time-box {
  margin-left: 50px;
  flex-shrink: 0;
  display: flex;
}
.addr-info-section .time-info {
  margin-left: 30px;
  text-align: center;
}
.addr-info-section .time-info .label {
  font-size: 12px;
  color: #91979d;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.addr-info-section .time-info .label i {
  margin-right: 6px;
  font-size: 14px;
}
.addr-info-section .time-info .val {
  font-weight: 500;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.section .info-item {
  display: flex;
  align-items: center;
  height: 45px;
}
.section .info-item.auto-height {
  margin: 10px 0;
  min-height: 45px;
  height: auto;
  align-items: flex-start;
}
.section .info-item.divider {
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid #e8eaf3;
}
.section .info-item .item-label {
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  width: 20%;
  min-width: 100px;
  max-width: 240px;
  flex-shrink: 0;
  flex-grow: 0;
}
.section .info-item .con-box {
  position: relative;
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  background: #f7f8fa;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.section .info-item .con-box .con {
  display: inline-block;
  max-width: calc(100% - 26px);
  color: #333;
}

.section .info-item .con,
.section .info-item .link-con {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.section .info-item .el-icon-copy-document {
  margin-left: 10px;
  cursor: pointer;
}

.section.trade-info-section .trade-item {
  padding: 15px 0;
}

.section.trade-info-section .trade-item:first-child {
  padding-top: 0;
}

.section.trade-info-section .trade-item + .trade-item {
  border-top: 1px solid #e8eaf3;
}

.empty-box {
  padding: 200px 300px;
}

.pagination-container {
  text-align: right;
  padding-top: 30px;
}
.tab-title {
  display: flex;
  align-items: center;
  color: #91979d;
  font-size: 14px;
  margin-bottom: 20px;
}
.tab-title .num {
  margin: 0 2px;
  color: #333;
  font-weight: bold;
}

@media (max-width: 1199px) {
  .result-box {
    width: 95% !important;
    margin: 40px auto;
  }
  .empty-box {
    padding: 150px 20px;
  }

  .section.trade-info-section .trade-item {
    padding: 15px 0;
  }
}

@media (max-width: 800px) {
  .result-box {
    width: 95% !important;
    margin: 20px auto;
  }
  .section .info-item {
    height: 40px;
  }
  .section .info-item .con-box {
    width: calc(100% - 100px);
  }
  .addr-info-section .time-box {
    display: none;
  }
  .pagination-container {
    padding-top: 20px;
  }
}

.record-table-wrapper {
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.record-table {
  width: 100%;
}

.record-table th,
.record-table td {
  padding: 0 30px;
  height: 48px;
  line-height: 48px;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
}
.record-table th {
  font-size: 14px;
  color: #6c757e;
  height: 42px;
  line-height: 42px;
  background: #f8fafd;
  border-top: 1px solid #e8eaf3;
}
.record-table th.center,
.record-table td.center {
  text-align: center;
}

.record-table td {
  font-size: 14px;
  color: #666;
  border-top: 1px solid #dee5eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue